import Validate from 'base/lib/validate'
import { isUniqueIdRequired } from 'base/lib/international/review_order_helper'

import 'jquery.payment'

// TODO: Refactor this. getSentenceErrors returns an array, but getErrors returns
// an object mapping the validation to the error string.
function mapValidationsToErrors(validations, { sentenceErrors } = {}) {
  const validator = new Validate({ verboseErrors: false })
  validator.validate(validations)

  if (sentenceErrors) {
    return validator.getSentenceErrors()
  } else {
    return validator.getErrors()
  }
}

export function getErrorsForResidentId(id, { sentenceErrors } = {}) {
  const validations = {
    unique_id: {
      label: 'Chinese ID number',
      value: id,
      validations: {
        pattern: 'chinese_identification_number',
        presence: true,
      },
    },
  }

  const mapped = mapValidationsToErrors(validations, { sentenceErrors })

  return mapped.unique_id
}

export function getErrorsForTaxId(id, country, { sentenceErrors } = {}) {
  const validations = {
    unique_id: {
      label: 'Tax ID',
      value: id,
      validations: {
        pattern: `${country.toLowerCase()}_intl_tax_number`,
        presence: true,
      },
    },
  }
  const mapped = mapValidationsToErrors(validations, { sentenceErrors })

  return mapped.unique_id
}

export function getAbsenceForAddressData(data) {
  const isInternational = data.country && !['US', 'CA'].includes(data.country)

  const validations = {
    full_name: {
      label: 'Full name',
      value: data.full_name,
      validations: {
        presence: true,
      },
    },
    first_name: {
      label: 'Given name',
      value: data.first_name,
      validations: {
        presence: data.country === 'CN',
      },
    },
    last_name: {
      label: 'Family name',
      value: data.last_name,
      validations: {
        presence: data.country === 'CN',
      },
    },
    street_address: {
      label: 'Street address',
      value: data.street_address,
      validations: {
        presence: true,
      },
    },
    extended_address: {
      label:
        data.country === 'CN'
          ? 'Address continued (Optional)'
          : 'Apartment, Suite, Building (Optional)',
      value: data.extended_address,
      validations: {
        presence: false,
      },
    },
    city: {
      label: data.country === 'CN' ? 'City, District' : 'City',
      value: data.city,
      validations: {
        presence: true,
      },
    },
    country: {
      label: 'Country',
      value: data.country,
      validations: {
        presence: true,
      },
    },
    region: {
      label: ['CA', 'CN'].includes(data.country) ? 'Province' : 'State',
      value: data.region,
      validations: {
        presence: ['CN', 'HK'].includes(data.country) || !isInternational,
      },
    },
    postal_code: {
      label: data.country === 'CA' ? 'Zip code' : 'Postal code',
      value: data.postal_code,
      validations: {
        presence: !isInternational,
      },
    },
    phone: {
      label: 'Phone number',
      value: data.phone,
      validations: {
        presence: !['US', 'CA'].includes(data.country),
      },
    },
    unique_id: {
      label: 'Tax Id',
      value: data.unique_id,
      validations: {
        presence: isUniqueIdRequired({ country: data.country }),
      },
    },
  }

  return mapValidationsToErrors(validations)
}

export function getErrorsForGiftcardData(data) {
  return mapValidationsToErrors({
    recipientName: {
      value: data.recipientName,
      validations: {
        presence: true,
      },
    },
    recipientEmail: {
      value: data.recipientEmail,
      validations: {
        presence: true,
        pattern: 'email',
      },
    },
    deliveryDate: {
      value: data.deliveryDate,
      validations: {
        presence: true,
      },
    },
  })
}

export function getErrorsForUserAccountData(data) {
  return mapValidationsToErrors({
    email: {
      value: data.email,
      validations: {
        presence: true,
        pattern: 'email',
      },
    },
  })
}

export function getErrorsForAuthData(data) {
  return mapValidationsToErrors({
    email: {
      value: data.email,
      validations: {
        presence: true,
        pattern: 'email',
      },
    },
    password: {
      value: data.password,
      validations: {
        presence: true,
      },
    },
  })
}
